/**
 * Role helpers.
 *
 * Hierarchy: hr > admin > user. An HR manager can do everything an admin can
 * (plus HR data), so admin-capability checks must treat 'hr' as admin-or-better.
 * Use hasAdminAccess() for every "is this user allowed to do admin things" gate;
 * reserve exact role comparisons (role === 'hr') for HR-only concerns.
 */

import type { Role } from '../types';

/** True for admins and HR managers (HR ranks above admin). */
export const hasAdminAccess = (role?: Role | null): boolean => role === 'admin' || role === 'hr';

/** True only for HR managers. */
export const isHr = (role?: Role | null): boolean => role === 'hr';

/** Human-readable role labels for badges, dropdowns, etc. */
export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Admin',
  user: 'User',
  hr: 'HR Manager',
};
